import {
  Button,
  DialogActions,
  Divider,
  ScrollableDialogContent,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { Cluster } from 'types/cluster';

import { AssignCredentialsFeaturesComplete } from '../../../../_components/AssignCredentialsFeaturesComplete';
import { LongAksOnboardingAlert } from '../../../../_components/LongAksOnboardingAlert';
import {
  ClusterDialogHeading,
  StepContainer,
} from '../../../../_components/new-onboarding';
import { useAssignCredentialsDialogV2Context } from '../context';

type Props = {
  cluster: Cluster;
};

export const AssignCredentialsDialogSuccessSlide = ({ cluster }: Props) => {
  const { dismiss, featureSelection } = useAssignCredentialsDialogV2Context();

  return (
    <StepContainer data-testid="success-step">
      <ClusterDialogHeading cluster={cluster} onClose={dismiss} />
      <ScrollableDialogContent>
        <Stack pt={20}>
          <Typography
            variant="L10M"
            color={tokens.theme.fg.structural.secondary}
            mb={8}
          >
            Enabled Features:
          </Typography>
          <AssignCredentialsFeaturesComplete
            enabledFeatures={featureSelection}
          />
        </Stack>

        <LongAksOnboardingAlert
          cluster={cluster}
          includeAutoscaler={featureSelection.autoscaler}
        />
      </ScrollableDialogContent>
      <Divider color="grey.100" />
      <DialogActions>
        <Button onClick={dismiss} testId="done-button">
          Done
        </Button>
      </DialogActions>
    </StepContainer>
  );
};
